import React from "react";
import prevArrow from "../images/prev-arrow.png";
import prevArrowW from "../images/prev-arrow_w.png";
import { useNavigate } from "react-router-dom";

export default function PageHeader({ isBlack, title, isUseMenu }) {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    }

    const handleOpenMenu = () => {
        const sideMenu = document.querySelector('#hamMenu'); // ✅ id로 선택
        sideMenu.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
    }

    return (
        <div class="pageHeader">
            <button class="btn-prev" onClick={handleGoBack}>
                <img class="icon-arrow" src={isBlack ? prevArrowW : prevArrow} alt="이전으로" />
            </button>
            <p class="pageTitle">{title}</p>
            {isUseMenu && (
                <button class="btn-hamberger" onClick={handleOpenMenu}>
                    <i class="x-icon"></i>
                </button>
            )}
        </div>
    );
}